export default {
    main: {
        首页: '首页',
        订单生成中: '订单生成中',
        请稍候: '请稍候...',
        安全支付: '安全支付',
        订单号: '订单号',
        金额: '金额',
        支付提示: '支付提示',
        请在: '请在',
        秒内: '秒内',
        完成: '完成',
        支付: '支付',
        超时会自动: '超时会自动',
        取消: '取消',
        生成中请稍候: '生成中，请稍候',
        剩余时间: '剩余时间',
        订单已失效: '订单已失效',
        订单已失效Memo: '请重新下单或者等待到账!',
        订单异常: '订单异常',
        发生错误: '发生错误',
        订单生成失败: '订单生成失败',
        暂无可用的订单: '暂无可用的订单',
        订单: '订单',
        已支付: '已支付',
        已超时: '已超时',
        生成失败: '生成失败',
        已支付Memo: '您的订单已确认支付成功，请关闭本页面后，确认使用到账。',
        已超时Memo: '您的订单支付超时，请关闭本页面后，重新下单即可。',
        生成失败Memo: '您的订单生成失败，请关闭本页面后，重新下单即可。',
    }
}
